import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import ReactGA from "react-ga4";

const RouteChangeTracker = () => {
  const location = useLocation();
  const navigationType = useNavigationType();

  // Save scroll position continuously for the current page
  useEffect(() => {
    const save = () => {
      sessionStorage.setItem(`scroll_${location.key}`, String(window.scrollY));
    };
    window.addEventListener('scroll', save, { passive: true });
    return () => window.removeEventListener('scroll', save);
  }, [location.key]);

  // Handle scroll on route change
  useEffect(() => {
    if (navigationType === 'POP') {
      const savedY = sessionStorage.getItem(`scroll_${location.key}`);
      if (savedY) {
        requestAnimationFrame(() => {
          window.scrollTo({ top: parseInt(savedY, 10), behavior: 'instant' });
        });
      } else {
        window.scrollTo({ top: 0, behavior: 'instant' });
      }
    } else {
      // PUSH or REPLACE — forward navigation, always go to top
      window.scrollTo({ top: 0, behavior: 'instant' });
    }

    if (import.meta.env.PROD && ReactGA.isInitialized) {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.search,
        title: document.title
      });
    }
  }, [location, navigationType]);

  return null;
};

export default RouteChangeTracker;
